"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastClickSelector = void 0;
function getLastClickSelector(state) {
    return state.interactions.pointer.lastClick;
}
exports.getLastClickSelector = getLastClickSelector;
//# sourceMappingURL=get_last_click.js.map